export const COUNTRIES = [
  { id: "de", name: "Germany", sub: "Student, Tourist, Family visit", live: true },
  { id: "uk", name: "United Kingdom", sub: "Standard Visitor", live: true },
  { id: "ca", name: "Canada", sub: "Coming soon", live: false },
  { id: "us", name: "United States", sub: "Coming soon", live: false },
];

export const VISAS = [
  { id: "tourist", label: "Tourist visit", tag: "Schengen, Type C", sub: "Up to 90 days for leisure" },
  { id: "family", label: "Family or friends visit", tag: "Schengen, Type C", sub: "Visiting relatives or friends in Germany" },
  { id: "student", label: "Student", tag: "National, Type D", sub: "University admission and blocked account" },
];

export const DOCS = [
  ["Passport", "Original plus copies of pages 1 and 2"],
  ["VIDEX application form", "Printed and signed. We prepare every answer"],
  ["Two biometric photographs", "Not older than 6 months"],
  ["Schengen health insurance", "Minimum cover 30,000 EUR"],
  ["Proof of accommodation", "All hotel bookings and itinerary"],
  ["Round-trip flight reservation", "Covering your whole stay"],
  ["CNIC copy", "A4 copy"],
  ["Family Registration Certificate", "NADRA, in English"],
  ["List of children and relatives abroad", "Official templates, signed. We fill these"],
  ["Financial evidence", "6 months of bank statements, last 3 salary slips"],
  ["Appointment e-mail printout", "E-mail registered with the mission"],
  ["Cover letter", "Short letter on the purpose of your trip. We draft this"],
  ["Visa fee", "90 EUR in PKR cash at the counter"],
];

const T = (en, ur) => ({ en, ur });

export const QUESTIONS = [
  {
    id: "who", kind: "choice",
    title: T("Who is travelling?", "سفر کون کر رہا ہے؟"),
    explain: T("Each traveller needs a separate application. Families can be prepared together so that documents are reused.", "ہر مسافر کی الگ درخواست ہوتی ہے۔ خاندان کی تیاری اکٹھی ہو سکتی ہے تاکہ دستاویزات دوبارہ استعمال ہوں۔"),
    options: [
      { v: "me", t: T("Just me", "صرف میں"), s: T("Single visa application", "ایک ویزا درخواست") },
      { v: "group", t: T("Travelling with family or a group", "خاندان یا گروپ کے ساتھ"), s: T("2 to 5 people, each gets an application", "2 سے 5 افراد، ہر ایک کی درخواست") },
    ],
  },
  {
    id: "job", kind: "choice",
    title: T("What is your current work status?", "آپ کی موجودہ ملازمت کی حیثیت کیا ہے؟"),
    explain: T("The mission asks for proof that you have ties to Pakistan. Your answer decides which letters we prepare for you.", "مشن پاکستان سے آپ کے تعلق کا ثبوت مانگتا ہے۔ آپ کا جواب طے کرتا ہے کہ ہم کون سے خطوط تیار کریں۔"),
    options: [
      { v: "emp", t: T("Employed", "ملازم"), s: T("Employment letter and salary slips", "ملازمت کا خط اور تنخواہ کی پرچیاں") },
      { v: "self", t: T("Self-employed or business owner", "کاروباری"), s: T("Business registration and tax returns", "کاروبار کی رجسٹریشن اور ٹیکس ریٹرن") },
      { v: "stu", t: T("Student", "طالب علم"), s: T("Enrolment proof", "داخلے کا ثبوت") },
      { v: "none", t: T("Not working", "ملازمت نہیں"), s: T("Sponsor documents", "کفیل کی دستاویزات") },
    ],
  },
  { id: "passport", kind: "passport", title: T("Passport details", "پاسپورٹ کی تفصیلات"), explain: T("We read the machine-readable lines at the bottom of the photo page. You review every value before it is saved.", "ہم تصویر والے صفحے کی مشین ریڈایبل لائنیں پڑھتے ہیں۔ محفوظ کرنے سے پہلے آپ ہر قدر دیکھتے ہیں۔") },
  { id: "upload", kind: "upload", title: T("Skip the typing", "ٹائپنگ چھوڑیں"), explain: T("Upload any of these and we fill your forms from them. Everything here is optional.", "ان میں سے کچھ اپ لوڈ کریں، ہم فارم بھر دیں گے۔ سب اختیاری ہے۔") },
];

export const UI = {
  welcome1: T("You have selected Germany, Tourist visa (Schengen, Type C), for the German Embassy in Islamabad.", "آپ نے جرمن سفارت خانہ اسلام آباد کے لیے جرمنی ٹورسٹ ویزا (شینجن، ٹائپ C) منتخب کیا ہے۔"),
  welcome2: T("The mission asks for a specific list of documents.", "مشن ایک مخصوص فہرست کی دستاویزات مانگتا ہے۔"),
  link: T("View the document list", "دستاویزات کی فہرست دیکھیں"),
  welcome3: T("We will help you prepare everything in the fastest way possible. Once that is done, we book your appointment for you.", "ہم تمام تیاری تیز ترین طریقے سے کروائیں گے۔ اس کے بعد آپ کی اپائنٹمنٹ ہم بک کریں گے۔"),
  explain: T("Explain this step", "اس مرحلے کی وضاحت"),
  back: T("Back", "واپس"),
  cont: T("Continue", "جاری رکھیں"),
};
